import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import SearchBar from '../../component//SearchBar'
import _ from 'lodash'
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap'

import { getCompaniesList, getAllCompanies } from '../../action/CompaniesActions'
import CustomButton from '../../component/CustomButton'

const RolloutBlacklistModal = (props) => {
	const { onHide, userRole, loaderModal, toggleLoaderModal } = props
	const [partnerCompanies, setPartnerCompanies] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');

	useEffect(() => {
		getCompanies();
	}, [])

	const getCompanies = () => {
		toggleLoaderModal(true);
		const companyType = 'customer,wcs';
		getAllCompanies(userRole, companyType)
			.then(async (res) => {
				const companies = await res.data.response.companies;
				let partners = [];
				const company_type = 'PARTNER';
				await getCompaniesList(userRole, company_type)
					.then((res, err) => {
						partners = _.sortBy(res.data.response['companies list'], (num) => num.toLowerCase())
					});
				let initPartnerCompanies = [];
				partners.map(partner => {
					let arr = [];
					companies.map(company => { if (company.partner_company === partner) arr.push(company) })
					initPartnerCompanies.push({ partner: partner, companies: arr });
				})
				setPartnerCompanies(initPartnerCompanies);
				setCompanies(companies);
				toggleLoaderModal(false);
			})
			.catch(error => {
				toggleLoaderModal(false);
				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const onSave = () => {
		console.log(selectedCompanies);
	}

	const filterGroups = (searchTermText = null) => {
		let searchTermValue = searchTerm;
		!!searchTermText ? searchTermValue = searchTermText : searchTermValue;
		return (
			partnerCompanies.reduce((totalGroups, group) => {
				if (group.partner.toLowerCase().includes(searchTerm.toLowerCase())) {
					totalGroups.push(group)
				}
				else {
					let companies = group.companies.filter(company => { company.company_name.toLowerCase().includes(searchTerm.toLowerCase()) })
					if (companies.length) {
						totalGroups.push({ ...group, ...{ companies } })
					}
				}
				return totalGroups
			}, [])
		)
	}

	const filterCompany = (searchTerm = null) => {
		return filterGroups(searchTerm).reduce((company, { companies }) => {
			companies.forEach(item => { company.push(item.company_name) })
			return company
		}, [])
	}

	const toggleCompany = (company_name) => {
		const newCompanies = selectedCompanies.includes(company_name) ? selectedCompanies.filter(company => company !== company_name) : [...selectedCompanies, company_name]
		setSelectedCompanies(newCompanies)
	}

	const toggleGroup = (e, partnerName) => {
		let newCompanies = [...selectedCompanies]
		const groupedCompanies = filterGroups().find(group => group.partner === partnerName).companies;
		for (let company of groupedCompanies) {
			if (e.target.checked) {
				!newCompanies.includes(company.company_name) && newCompanies.push(company.company_name)
			}
			else {
				newCompanies.includes(company.company_name) && newCompanies.splice(newCompanies.indexOf(company.company_name), 1)
			}
		}
		setSelectedCompanies(newCompanies)
	}

	const onSearch = (e) => {
		const searchTerm = e.target.value;
		setSearchTerm(searchTerm);
		let updateSelectedCompanies = selectedCompanies;
		let filteredSearchIds = filterCompany(searchTerm);
		updateSelectedCompanies.map(value => { if (!filteredSearchIds.includes(value)) updateSelectedCompanies = updateSelectedCompanies.filter(item => item !== value) });
		setSelectedCompanies(updateSelectedCompanies);
	}

	const renderCompanyRow = (argCompany, argSelectedCompany) => {
		return (
			<div className="asset-select-wrapper" key={argCompany} style={{ paddingLeft: '0px' }}>
				<input
					type="checkbox"
					checked={argSelectedCompany.includes(argCompany)}
					onChange={() => toggleCompany(argCompany)}
				/>
				<span className="asset-name">{argCompany}</span>
			</div>
		)
	}

	const isGroupChecked = (index) => {
		let groupSelectedCompanies = [];
		filterGroups()[index].companies.map(company => {
			groupSelectedCompanies.push(company.company_name);
		})
		if (groupSelectedCompanies.length && groupSelectedCompanies.every(company => selectedCompanies.includes(company))) {
			return true;
		}
		else {
			return false;
		}
	}

	return (
		<Modal
			show
			onHide={onHide}
			className='rolloutBlacklistModal modal-lg-size'
		>
			<Modal.Header closeButton>
				<Modal.Title className="contained-modal-title">Firmware Rollout Blacklist</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className='rolloutBlacklist-modal-body'>
					Checking a company in this list adds it to the firmware rollout blacklist.
					Devices in the companies added to this list <span>will NOT receive automatic firmware updates when a rollout is started</span>.
					Instead devices in these companies will have to be manually updated in the Firmware Portal.
					Devices in a company will resume getting automatic firmware updates if the company is removed from the list by unchecking it.
				</div>
				<div className='select-box'>
					<div className='select-box-wrapper'>
						<SearchBar term={searchTerm} onSearch={onSearch} placeholder='Search companies...' />
						<div className='select-box-body'>
							{partnerCompanies.length > 0 && filterGroups().map((group, index) =>
								<div className='group-list' key={group.partner}>
									<div className='asset-select-wrapper'>
										<input
											type='checkbox'
											checked={isGroupChecked(index)}
											onChange={(e) => toggleGroup(e, group.partner)}
										/>
										<strong>
											{group.partner}
										</strong>
									</div>
									<div className='vehicle-list'>
										<div className="vehicle-list">
											{group.companies.map(company => renderCompanyRow(company.company_name, selectedCompanies))}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div>
					<CustomButton type="button" variant="primary-outline" onClick={onHide}>
						Cancel
					</CustomButton>
					<CustomButton type="button" variant="secondary" disabled={!selectedCompanies.length} onClick={onSave}>
						Save
					</CustomButton>
				</div>
			</Modal.Footer>
			{loaderModal}
		</Modal>
	);
}

const mapStateToProps = (state) => ({
	company: state.company.company,
	loaderModal: state.loader.loaderModal,
});

const mapDispatchToProps = (dispatch) => ({
	toggleLoaderModal: (show) => dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show })
});

export default connect(mapStateToProps, mapDispatchToProps)(RolloutBlacklistModal);
